export const educationData = [
	{
		id: "10thBoard",
		label: "10th Board *",
		placeholder: "",
		type: "condSelect",
		helerText: "SSC/CBSE/IGSE/IB",
		validationType: "string",
		value: "",
		options: [
			"SSC",
			"CBSE",
			"ICSE",
			"IB",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["Board is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "10thPercentage",
		label: "Percentage or Grade scored in 10th *",
		placeholder: "",
		type: "text",
		helperText: "Percentage obtained in 10th",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["10th Percentage is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "studyCompleted2025-2026",
		label: "Last year's education completed in 2025-26 *",
		placeholder: "",
		type: "condSelect",
		helperText: "Course/Standard completed",
		validationType: "string",
		value: "",
		options: [
			"11th",
			"12th",
			"Diploma",
			"1st year",
			"2nd year",
			"3rd year",
			"4th year",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["Education completed is required"],
			},
		],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "percentage2025-2026",
		label: "Percentage or Grade in 2025-26 *",
		placeholder: "",
		type: "text",
		helperText: "Please fill % or Grade obtained in previous year",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["Previous year % or Grade is required"],
			},
		],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "12thBoard",
		label: "12th Board *",
		placeholder: "",
		type: "condSelect",
		helerText: "SSC/CBSE/IGSE/IB",
		validationType: "string",
		value: "",
		options: [
			"HSC",
			"CBSE",
			"ICSE",
			"IB",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["Board is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
		rules: {
			and: [
				{ "!=": [{ var: "studyCompleted2025-2026" }, "Diploma"] },
				{ "!=": [{ var: "studyCompleted2025-2026" }, "11th"] },
			],
		},
	},
	{
		id: "12thPercentage",
		label: "Percentage or Grade scored in 12th *",
		placeholder: "",
		type: "text",
		helperText: "Percentage obtained in 12th",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["12th Percentage is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
		rules: {
			and: [
				{ "!=": [{ var: "studyCompleted2025-2026" }, "Diploma"] },
				{ "!=": [{ var: "studyCompleted2025-2026" }, "11th"] },
			],
		},
	},
	{
		id: "course2026-2027",
		label: "Course *",
		placeholder: "",
		helperText:
			"Select current Course, should be a student from the following options",
		type: "condSelect",
		validationType: "string",
		value: "",
		options: [
			"Engineering",
			"Architect",
			"Interior Designing",
			"Video Editing / VFX",
			"Graphic Desigining",
			"Commerce (BCom / MCom / etc)",
			"Arts (BA / MA)",
			"Medical",
			"Science(BSc / MSc)",
			"Masters",
			"PhD",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["course is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "college2026-2027",
		label: "Current college / institution Name *",
		placeholder: "",
		type: "text",
		helperText: "College / Institution",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["College / Institution name is required"],
			},
		],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "CurrentUniversity2026-2027",
		label: "Current University / Institute *",
		placeholder: "",
		type: "condSelect",
		helerText: "Mumbai Univeristy / SNDT / Others ?",
		validationType: "string",
		value: "",
		options: [
			"Mumbai University",
			"SNDT",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["University / Institute is required"],
			},
		],
		action: [{ type: "required" }],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "studyApplied2026-2027",
		label: "Study Applied in 2026-27 *",
		placeholder: "Study applied in 2026-27",
		type: "condSelect",
		helperText: "",
		validationType: "string",
		value: "",
		options: [
			"11th",
			"12th",
			"1st year",
			"2nd year",
			"3rd year",
			"4th year",
			"Other (if other please specify)",
		],
		validations: [
			{
				type: "required",
				params: ["Please specify your course"],
			},
		],
		isProfile: true,
		isEditableProfile: false,
	},
	{
		id: "pastScholarshipReceived",
		label: "SVGA Scholarship Received? *",
		placeholder: "",
		type: "radio",
		helerText: "Mention YES in case of any scholarship received from SVGA",
		validationType: "string",
		value: "",
		options: ["YES", "NO"],
		validations: [
			{
				type: "required",
				params: ["Select any one"],
			},
		],
	},
	{
		id: "pastLaptopApplied",
		label: "Received laptop in past from SVGA? *",
		placeholder: "",
		type: "radio",
		helerText:
			"Mention YES in case of laptop received from SVGA in past few years",
		validationType: "string",
		value: "",
		options: ["YES", "NO"],
		validations: [
			{
				type: "required",
				params: ["Select any one"],
			},
		],
	},
	{
		id: "computerUsage",
		label: "Computer usage in your Studies *",
		placeholder: "",
		type: "textarea",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["This field is required"],
			},
		],
	},
	{
		id: "computerKnowledge",
		label: "Computer Knowledge *",
		placeholder: "Computer Courses done",
		type: "text",
		validationType: "string",
		value: "",
		validations: [
			{
				type: "required",
				params: ["Computer Knowledge is required"],
			},
		],
	},
	{
		id: "laptopPreference",
		label: "Laptop Preference (11th, 12th & Graduation) *",
		placeholder: "",
		type: "select",
		helperText:
			"Acer Aspire 3 (Silver) — Intel Core i3 1305U, 8 GB DDR4 RAM, 500 GB NVMe. Laptop payable: Rs. 23,250/- (with bag). Mandatory warranty: Rs. 2,000/-; students pay Rs. 1,000/- after 50% subsidy, payable separately. Market price: Rs. 46,500/- (Approx). ચૂકવવાની રકમ ₹23,250. વોરંટી માટે ચૂકવવાની રકમ ₹1,000 અલગથી ચૂકવવાની રહેશે.",
		validationType: "string",
		value: "",
		options: ["Intel i3 laptop"],
		validations: [
			{
				type: "required",
				params: ["Config is required"],
			},
		],
		action: [{ type: "required" }],
		rules: {
			or: [
				{ "==": [{ var: "studyApplied2026-2027" }, "11th"] },
				{ "==": [{ var: "studyApplied2026-2027" }, "12th"] },
				{
					"==": [
						{ var: "course2026-2027" },
						"Commerce (BCom / MCom / etc)",
					],
				},
				{ "==": [{ var: "course2026-2027" }, "Arts (BA / MA)"] },
				{ "==": [{ var: "course2026-2027" }, "Medical"] },
				{ "==": [{ var: "course2026-2027" }, "Science(BSc / MSc)"] },
				{ "==": [{ var: "course2026-2027" }, "Masters"] },
				{ "==": [{ var: "course2026-2027" }, "PhD"] },
			],
		},
	},
	{
		id: "laptopPreferenceHighEnd",
		label: "Laptop Preference (Professional Courses) *",
		placeholder: "",
		type: "select",
		helperText:
			"Acer Aspire 3 (Silver) — Intel Core i5 1334U, 8 GB DDR4 RAM, 500 GB NVMe. Laptop payable: Rs. 28,150/- (with bag). Mandatory warranty: Rs. 2,000/-; students pay Rs. 1,000/- after 50% subsidy, payable separately. Market price: Rs. 56,300/- (Approx). ચૂકવવાની રકમ ₹28,150. વોરંટી માટે ચૂકવવાની રકમ ₹1,000 અલગથી ચૂકવવાની રહેશે.",
		validationType: "string",
		value: "",
		options: ["Intel i5 laptop"],
		validations: [
			{
				type: "required",
				params: ["Config is required"],
			},
		],
		action: [{ type: "required" }],
		rules: {
			or: [
				{ "==": [{ var: "course2026-2027" }, "Engineering"] },
				{ "==": [{ var: "course2026-2027" }, "Architect"] },
				{ "==": [{ var: "course2026-2027" }, "Interior Designing"] },
				{ "==": [{ var: "course2026-2027" }, "Video Editing / VFX"] },
				{ "==": [{ var: "course2026-2027" }, "Graphic Desigining"] },
			],
		},
	},
	{
		id: "ramOption",
		label: "Avail 20GB RAM version (Only for i3 and i5 laptops)",
		placeholder: "",
		type: "checkbox",
		helperText: "",
		validationType: "string",
		value: "",
		options: ["Avail 20GB RAM version"],
		validations: [],
		// rules: {
		// 	or: [
		// 		{ "==": [{ var: "course2026-2027" }, "Engineering"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Architect"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Interior Designing"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Video Editing / VFX"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Graphic Desigining"] },
		// 	],
		// },
	},
	{
		id: "warrantyAcknowledgement",
		label: "Mandatory Warranty *",
		placeholder: "",
		type: "checkbox",
		helperText: "Warranty is compulsory for every laptop.",
		validationType: "string",
		value: "",
		options: [
			"I agree to the compulsory warranty: Rs. 2,000/- (students pay Rs. 1,000/- after 50% subsidy).",
		],
		validations: [
			{
				type: "required",
				params: ["Warranty acknowledgement is required"],
			},
		],
		action: [{ type: "required" }],
	},
	{
		id: "ramOptionInfo",
		label: "",
		placeholder: "",
		type: "statictext",
		validationType: "string",
		value: "If want to apply for 20GB RAM version NOTE: (Only for i3 and i5 laptops): If students want to configure their i3 or i5 laptop to 20 GB RAM, then additional cost of Rs. 2500/- will be charged separately (Actual cost is Rs. 5000/-)",
		validations: [],
		preview: false,
		action: [{ type: "required" }],
		// rules: {
		// 	or: [
		// 		{ "==": [{ var: "course2026-2027" }, "Engineering"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Architect"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Interior Designing"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Video Editing / VFX"] },
		// 		{ "==": [{ var: "course2026-2027" }, "Graphic Desigining"] },
		// 	],
		// },
	},
];
